import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useHistory } from 'react-router-dom';

import * as lessonViewActions from 'common.components/lesson-view.store/actions';
import * as lessonSelectors from 'common.components/lesson/selectors';
import Results from 'common.components/results/results';
import { actions as problemsViewActions } from 'store/problems-view/actions';
import { stickersActions } from 'store/stickers/actions';

import { LessonViewInformationBannersContainer } from '../__information-banners/lesson-view__information-banners.container';

import './lesson-view__results.scss';

interface Props {
    hideBanners?: boolean;
}

export const LessonViewResultsWithInformationBanners = ({ hideBanners }: Props) => {
    const dispatch = useDispatch();
    const clessonId = useSelector(lessonSelectors.getCLessonId);
    const lessonMeta = useSelector(lessonSelectors.getLessonMeta);
    const courseId = useSelector(lessonSelectors.getLessonCourseId);

    useEffect(() => {
        if (lessonMeta && lessonMeta.stickers_slugs) {
            const stickerSlugs = lessonMeta.stickers_slugs;
            dispatch(stickersActions.getClessonMetaStickersRequest({ stickerSlugs }));
        } else {
            dispatch(stickersActions.resetClessonMetaStickers());
        }

        if (clessonId) {
            dispatch(stickersActions.getClessonStudentsStickersRequest({ clessonId }));
        }
    }, [lessonMeta, clessonId, dispatch]);

    const handleHeaderCardClick = useCallback(
        (problemId: number) => {
            dispatch(problemsViewActions.setSelectedProblemId(problemId));
        },
        [dispatch]
    );

    const { search, pathname } = useLocation();
    const history = useHistory();
    useEffect(() => {
        const queryParams = new URLSearchParams(search);
        const problemId = queryParams.get('problemId');
        if (problemId) {
            queryParams.delete('problemId');
            handleHeaderCardClick(Number(problemId));
            history.replace(pathname + '?' + queryParams.toString());
        }
    }, [search, history, pathname, handleHeaderCardClick]);

    const handleStudentNameClick = useCallback(
        (studentId: number) => {
            dispatch(lessonViewActions.setSelectedStudentId(studentId));
        },
        [dispatch]
    );

    const handleAssignClessonStudentsSticker = useCallback(
        (args: { studentIds: number[]; slug: string }) => {
            if (courseId && clessonId) {
                dispatch(
                    stickersActions.assignClessonStudentsSticker({
                        courseId,
                        clessonId,
                        ...args,
                    })
                );
            }
        },
        [courseId, clessonId, dispatch]
    );
    const handleCancelClessonStudentsSticker = useCallback(
        (args: { reactionIds: string[]; studentIds: number[] }) => {
            if (clessonId) {
                dispatch(stickersActions.cancelClessonStudentsSticker(args));
            }
        },
        [clessonId, dispatch]
    );

    let cn = 'lesson-view__results';
    if (lessonMeta?.stickers_slugs) {
        cn += ' lesson-view__results_stickers_yes';
    }

    return (
        <div className={cn}>
            {!hideBanners && <LessonViewInformationBannersContainer />}
            <Results
                onAssignClessonStudentsSticker={handleAssignClessonStudentsSticker}
                onCancelClessonStudentsSticker={handleCancelClessonStudentsSticker}
                onHeaderCardClick={handleHeaderCardClick}
                onStudentNameClick={handleStudentNameClick}
            />
        </div>
    );
};
